import { utils } from 'ethers'
import { memoize } from 'lodash'
import type { Chains } from 'modules/blockChain/chains'
import { PoolAsset } from '../constants/poolAssets'
import { PoolRisk } from '../constants/PoolRisk'

import {
  ContractInvestorRuSDC1,
  ContractInvestorRuSDC2,
  ContractInvestorRuSDC3,
} from 'modules/contracts/contracts'

export const POOL_INVESTORS_COLLECTION = [
  // USDC
  {
    asset: PoolAsset.USDC,
    risk: PoolRisk.LOW,
    contract: ContractInvestorRuSDC1,
  } as const,
  {
    asset: PoolAsset.USDC,
    risk: PoolRisk.MIDDLE,
    contract: ContractInvestorRuSDC2,
  } as const,
  {
    asset: PoolAsset.USDC,
    risk: PoolRisk.HIGH,
    contract: ContractInvestorRuSDC3,
  } as const,
] as const

export const getPoolInvestorByAssetAndRisk = memoize(
  (asset: PoolAsset, risk: PoolRisk) => {
    const contract = POOL_INVESTORS_COLLECTION.find(
      i => i.asset === asset && i.risk === risk,
    )
    if (!contract) throw new Error(`No investor contract for ${asset}`)
    return contract
  },
  (...args) => args.join('-'),
)

export const getPoolInvestorByAddress = memoize(
  (chainId: Chains, address: string) => {
    const item = POOL_INVESTORS_COLLECTION.find(
      i => i.contract.chainAddress.get(chainId) === utils.getAddress(address),
    )
    if (!item) throw new Error(`No investor contract for ${address}`)
    return item
  },
  (...args) => args.join('-'),
)
